export default "__VITE_ASSET__Cve5433$__"